/* MY GIFT — gift builder interactivity (ported 1:1 from designer mockup) */
(function () {
  'use strict';

  function initBuilder(root) {
    if (root.dataset.mygiftInit) return;
    root.dataset.mygiftInit = 'true';

    var copy = JSON.parse(root.querySelector('[data-mygift-copy]').textContent);

    var state = {
      /* Group gifting is gone: no processor settles a split payment, so the
         chooser was removed and the flow is always the personal one. */
      mode: 'personal',
      step: 1,
      amount: copy.defaultAmount,
      customAmount: '',
      recipient: copy.defaultRecipient,
      sender: copy.defaultSender,
      phone: '',
      blessing: copy.defaultBlessing,
      delivery: 'now',
      channel: 'sms',
      occasion: (copy.occasions || [])[0] || '',
      groupName: '',
      deadline: '',
      groupTarget: null,
      completed: false
    };

    var q = function (sel) { return root.querySelector(sel); };
    var qa = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    var modeButtons = qa('[data-mode-btn]');
    var stepButtons = qa('[data-step-btn]');
    var lines = qa('[data-line]');
    var panels = qa('[data-panel]');
    var amountButtons = qa('[data-amount]');
    var customAmountInput = q('[data-custom-amount]');
    var occasionButtons = qa('[data-occasion]');
    var targetButtons = qa('[data-target]');
    var deliveryButtons = qa('[data-delivery]');
    var channelButtons = qa('[data-channel]');
    var blessingInput = q('[data-blessing]');
    var blessingCount = q('[data-blessing-count]');
    var backButton = q('[data-back]');
    var primaryLabel = q('[data-primary-label]');
    var successNote = q('[data-success]');
    var successTitle = q('[data-success-title]');
    var successText = q('[data-success-text]');
    var step2Sub = q('[data-step2-sub]');
    var step3Text = q('[data-step3-text]');
    var previewTag = q('[data-preview-tag]');
    var cardValueLabel = q('[data-card-value-label]');
    var cardValue = q('[data-card-value]');
    var cardName = q('[data-card-name]');
    var previewMessage = q('[data-preview-message]');

    function selectedAmount() {
      if (state.customAmount) {
        var value = Number(state.customAmount);
        return Math.max(0, isFinite(value) ? value : 0);
      }
      return state.amount;
    }

    function render() {
      modeButtons.forEach(function (b) {
        var active = b.dataset.modeBtn === state.mode;
        b.classList.toggle('active', active);
        b.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      stepButtons.forEach(function (b) {
        var n = Number(b.dataset.stepBtn);
        b.classList.toggle('active', state.step >= n);
        if (state.step === n) b.setAttribute('aria-current', 'step');
        else b.removeAttribute('aria-current');
        var span = b.querySelector('span');
        if (n < 3) span.textContent = state.step > n ? '✓' : String(n);
      });
      lines.forEach(function (line) {
        line.classList.toggle('active', state.step > Number(line.dataset.line));
      });
      step2Sub.textContent = state.mode === 'personal' ? copy.step2SubPersonal : copy.step2SubGroup;
      step3Text.textContent = state.mode === 'personal' ? copy.step3TextPersonal : copy.step3TextGroup;

      panels.forEach(function (panel) {
        var key = panel.dataset.panel;
        var visible =
          (key === 'p1' && state.step === 1 && state.mode === 'personal') ||
          (key === 'g1' && state.step === 1 && state.mode === 'group') ||
          (key === 'p2' && state.step === 2 && state.mode === 'personal') ||
          (key === 'g2' && state.step === 2 && state.mode === 'group') ||
          (key === 's3' && state.step === 3);
        panel.hidden = !visible;
      });

      amountButtons.forEach(function (b) {
        var active = !state.customAmount && state.amount === Number(b.dataset.amount);
        b.classList.toggle('active', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      occasionButtons.forEach(function (b) {
        b.classList.toggle('active', state.occasion === b.dataset.occasion);
      });
      targetButtons.forEach(function (b) {
        var value = b.dataset.target === 'open' ? null : Number(b.dataset.target);
        b.classList.toggle('active', state.groupTarget === value);
      });
      channelButtons.forEach(function (b) {
        var on = state.channel === b.dataset.channel;
        b.classList.toggle('active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      /* The recipient email field is added by the gift app bridge, so match on
         the attribute rather than holding a reference that may not exist yet. */
      qa('[data-channel-field]').forEach(function (f) {
        f.hidden = f.getAttribute('data-channel-field') !== state.channel;
      });
      deliveryButtons.forEach(function (b) {
        b.classList.toggle('active', state.delivery === b.dataset.delivery);
      });

      if (blessingCount) blessingCount.textContent = state.blessing.length + '/180';

      backButton.hidden = state.step === 1;
      primaryLabel.textContent =
        state.step < 3
          ? copy.ctaNext
          : state.mode === 'personal'
            ? copy.ctaCreatePersonal
            : copy.ctaCreateGroup;

      successNote.hidden = !state.completed;
      successTitle.textContent = copy.successTitle;
      successText.textContent = state.mode === 'personal' ? copy.successPersonal : copy.successGroup;

      previewTag.textContent = state.mode === 'personal' ? copy.previewTagPersonal : copy.previewTagGroup;
      cardValueLabel.textContent = state.mode === 'personal' ? copy.cardValuePersonal : copy.cardValueGroup;
      cardValue.textContent =
        state.mode === 'personal'
          ? '₪' + selectedAmount()
          : state.groupTarget
            ? '₪' + state.groupTarget
            : copy.cardValueOpen;
      cardName.textContent =
        state.mode === 'personal'
          ? state.recipient || copy.fallbackRecipient
          : state.groupName || state.occasion;
      previewMessage.textContent =
        state.step === 3
          ? '״' + (state.blessing || copy.fallbackBlessing) + '״'
          : state.mode === 'personal'
            ? copy.fromPrefix + (state.sender || copy.fallbackSender) + copy.toWord + (state.recipient || copy.fallbackRecipient)
            : copy.groupPreviewMessage;
    }

    function goToStep(step) {
      state.step = step;
      state.completed = false;
      render();
    }

    modeButtons.forEach(function (b) {
      b.addEventListener('click', function () {
        state.mode = b.dataset.modeBtn;
        state.step = 1;
        state.completed = false;
        render();
      });
    });
    stepButtons.forEach(function (b) {
      b.addEventListener('click', function () { goToStep(Number(b.dataset.stepBtn)); });
    });
    backButton.addEventListener('click', function () { goToStep(state.step - 1); });
    q('[data-primary]').addEventListener('click', function () {
      if (state.step < 3) {
        goToStep(state.step + 1);
      } else {
        state.completed = true;
        render();
      }
    });

    amountButtons.forEach(function (b) {
      b.addEventListener('click', function () {
        state.amount = Number(b.dataset.amount);
        state.customAmount = '';
        customAmountInput.value = '';
        render();
      });
    });
    customAmountInput.addEventListener('input', function () {
      state.customAmount = customAmountInput.value;
      render();
    });
    occasionButtons.forEach(function (b) {
      b.addEventListener('click', function () {
        state.occasion = b.dataset.occasion;
        render();
      });
    });
    targetButtons.forEach(function (b) {
      b.addEventListener('click', function () {
        state.groupTarget = b.dataset.target === 'open' ? null : Number(b.dataset.target);
        render();
      });
    });
    channelButtons.forEach(function (b) {
      b.addEventListener('click', function () {
        state.channel = b.dataset.channel;
        render();
        document.dispatchEvent(new CustomEvent('mygift:channel', { detail: { channel: state.channel } }));
      });
    });
    deliveryButtons.forEach(function (b) {
      b.addEventListener('click', function () {
        state.delivery = b.dataset.delivery;
        render();
      });
    });

    qa('[data-input-recipient]').forEach(function (input) {
      input.addEventListener('input', function () {
        state.recipient = input.value;
        qa('[data-input-recipient]').forEach(function (other) {
          if (other !== input) other.value = input.value;
        });
        render();
      });
    });
    var senderInput = q('[data-input-sender]');
    if (senderInput) {
      senderInput.addEventListener('input', function () {
        state.sender = senderInput.value;
        render();
      });
    }
    var groupNameInput = q('[data-input-group-name]');
    if (groupNameInput) {
      groupNameInput.addEventListener('input', function () {
        state.groupName = groupNameInput.value;
        render();
      });
    }
    blessingInput.addEventListener('input', function () {
      state.blessing = blessingInput.value;
      render();
    });

    render();
  }

  function initAll() {
    document.querySelectorAll('[data-mygift-builder]').forEach(initBuilder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-mygift-builder]');
    if (el) initBuilder(el);
  });
})();
